// @flow

import { REDUCER_KEY } from './constants';

/**
 * Returns this feature's root state.
 *
 * @param {Object} state - Global state.
 * @returns {Object} Feature state.
 */
const getState = (state: Object) => state[REDUCER_KEY];

export const getMaterialListOpen = (state: Object) => Boolean(getState(state)?.isOpen);
